import { EmptyState, Loading } from '@gorila-shared-ui/components';
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import { EXTRA_LARGE_LIST_ITEM_HEIGHT } from '../../constants/app';
import useEffectOnce from '../../hooks/useEffectOnce';
import { useStyles } from '../../hooks/useStyles';
import { linkIdsState, linksPageState, linksState, loadingLinksState, selectedLinkIdState } from '../../storage/links';
import { Link } from '../../types/link';
import { FloatingCardContent } from '../layout/cards/FloatingCardContent';
import { VirtualizedPaginatedList } from '../shared/VirtualizedPaginatedList';
import LinkFilters from './LinkFilters';
import LinkItem from './LinkItem';

export function LinkList() {
  const { theme } = useStyles();
  const linkIds = useRecoilValue(linkIdsState);
  const resetSelectedLinkId = useResetRecoilState(selectedLinkIdState);
  const loadingLinks = useRecoilValue(loadingLinksState);
  const paginatedLinks = useRecoilValue(linksState);
  const setLinksPage = useSetRecoilState(linksPageState);

  useEffectOnce(() => {
    return () => {
      resetSelectedLinkId();
    };
  });

  return (
    <FloatingCardContent
      flexible
      gap={theme.sizing.scale600}
    >
      {!linkIds && !loadingLinks && <EmptyState title="Todavía no tienes ninguna vinculación" />}
      {!linkIds && loadingLinks && <Loading />}
      {linkIds && (
        <>
          <LinkFilters />
          <VirtualizedPaginatedList<Link>
            ids={linkIds}
            loading={loadingLinks}
            onNextPage={setLinksPage}
            paginatedResponse={paginatedLinks}
            itemComponent={LinkItem}
            itemSize={EXTRA_LARGE_LIST_ITEM_HEIGHT}
          />
          {!linkIds.length && (
            <EmptyState
              title="No se encontraron resultados"
              description="Intenta con otra busqueda"
            />
          )}
        </>
      )}
    </FloatingCardContent>
  );
}
